import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`About`}</h1>
    <p>{`Experienced Full Stack Web Developer with a demonstrated history of working in the information technology and services industry. Strong engineering professional skilled in PHP Applications, Programming, and JavaScript. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      